import { useSmarPanelToolEvaluationUrls } from './useSmarPanelToolEvaluationUrls';

export function useSmarPanelAccessMonitorUrl() {
  const evaluationUrls = useSmarPanelToolEvaluationUrls();

  return evaluationUrls.accessmonitor;
}
